import * as React from 'react';

type SlideOneProps = {
    onDismiss?: (arg1: React.SyntheticEvent<any>) => void;
    onNext?: (arg1: React.SyntheticEvent<any>) => void;
    cancelButtonText: string;
};

class SlideOne extends React.Component<SlideOneProps> {
    render() {
        return (
            <div className='slide-one'>
                <h1 className='header'>
                    Click-to-call
                    <p>It’s easy to make calls with Nutshell.</p>
                </h1>
                <div className='slide-one-graphic' />
                <p>
                    Make phone calls to any number with click-to-call. Calls and your notes are
                    automatically logged as activities in Nutshell. Use Skype, RingCentral or Kixie
                    at no extra charge, or upgrade to Nutshell Pro and make calls directly from your
                    browser.
                </p>
                <button
                    role='button'
                    className='ui-btn ui-btn--grey ui-btn--big'
                    onClick={this.props.onDismiss}
                >
                    <span>{this.props.cancelButtonText}</span>
                </button>
                <button
                    role='button'
                    className='ui-btn ui-btn--blue ui-btn--big'
                    onClick={this.props.onNext}
                >
                    <span>Tell me more</span>
                </button>
            </div>
        );
    }
}

type SlideTwoProps = {
    onDismiss?: (arg1: React.SyntheticEvent<any>) => void;
    onSetupPhone?: (arg1: React.SyntheticEvent<any>) => void;
    cancelButtonText: string;
};

class SlideTwo extends React.Component<SlideTwoProps> {
    render() {
        return (
            <div className='slide-two'>
                <h1 className='header'>How does it work?</h1>
                <div className='slide-two-graphic' />
                <div className='cols'>
                    <div>Click a phone number.</div>
                    <div>
                        We’ll dial your contact straight
                        <br />
                        from your web browser.
                    </div>
                    <div>
                        When the call ends, we log it
                        <br />
                        with the recording and notes.
                    </div>
                </div>
                <button
                    role='button'
                    className='ui-btn ui-btn--grey ui-btn--big'
                    onClick={this.props.onDismiss}
                >
                    <span>{this.props.cancelButtonText}</span>
                </button>
                <a
                    role='button'
                    href='/my-account/phone'
                    className='ui-btn ui-btn--blue ui-btn--big'
                    onClick={this.props.onSetupPhone}
                >
                    <span>Set up click-to-call</span>
                </a>
            </div>
        );
    }
}

export {SlideOne, SlideTwo};
